<template>
  <section id="home-hero" class="section-header flush">
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-5 order-2 order-md-1">
          <QuickFind />
        </div>

        <div class="col-12 col-md-7 order-1 order-md-2">
          <HomeFeaturedNews />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import HomeFeaturedNews from '@/components/home/HomeFeaturedNews.vue';
import QuickFind from '@/components/quickfind/Quickfind.vue';

export default {
  name: 'HomeHero',

  components: {
    HomeFeaturedNews,
    QuickFind,
  },
};
</script>

<style lang="scss" scoped>
  @include media ("<=tablet") {
    #home-hero {
      padding-top: 50px;
    }
  }
</style>
